import {store} from "../redux/store/store";
import {authConfig} from "./authConfig";
import OktaAuthService from "./authService";

export const globalStore = store;

// Set to true to run against a mit-student-support instance running locally
// (e.g. localhost:8082) via the dev.webpack.config.js devServer.proxy entry, instead
// of the shared mulesoft-proxy.api-dev.mit.edu backend. baseUrl must stay a relative
// path (not an absolute host) for that proxy to be able to intercept requests at all -
// an absolute cross-origin URL here bypasses the dev server and hits the browser's
// CORS policy directly.
const USE_LOCAL_BACKEND = false;

class StudentController
{
    baseUrl: string;
    hostUrl: string;
    authService?: any;
    authConfig?: any;
    stage?: string | null;

    constructor() {
        this.baseUrl = "";
        this.hostUrl = window.location.origin;
        this.stage = '';
        this.authConfig = authConfig();
        this.authService = new OktaAuthService(this.authConfig);

        if (this.hostUrl.indexOf('localhost') >= 0 || this.hostUrl.indexOf('canopy-portal.atlas-apps-dev') >= 0 || this.hostUrl.indexOf('canopy-dev.mit.edu') >= 0 || this.hostUrl.indexOf('127.0.0.1') >= 0) {
            this.stage = '-dev';
        } else if (this.hostUrl.indexOf('canopy-portal.atlas-apps-test') >= 0 || this.hostUrl.indexOf('canopy-test.mit.edu') >= 0) {
            this.stage = '-test';
        } else if (this.hostUrl.indexOf('canopy-portal.atlas-apps') >= 0 || this.hostUrl.indexOf('canopy.mit.edu') >= 0) {
            this.stage = '';
        }

       this.baseUrl = (this.stage === '-dev' && USE_LOCAL_BACKEND) ? '' : 'https://mulesoft-proxy.api' + this.stage + '.mit.edu';

    }

    async getPostHeader(): Promise<Headers> {
        const accessToken = await this.authService.getAccessToken();
        const headers: Headers = new Headers({
            "Content-Type": "application/json",
            "Method": "post",
            "Authorization": `Bearer ${accessToken}`,
        });
        //const URL_CSRF_API = PRODUCTION ? "/apis/mulesoft/csrf_session_token" : "/mock/student/csrf_session_token";
        //let csrfToken = "";
        // const csrfTokenResponse = await fetch(URL_CSRF_API);
        // if (csrfTokenResponse.status == 200) {
        //     if (csrfTokenResponse.headers.has("com.sap.cloud.security.login")) {
        //         headers.append("com.sap.cloud.security.login", "com.sap.cloud.security.login");
        //     } else {
        //         csrfToken = await csrfTokenResponse.text();
        //         headers.append("X-CSRF-Token", csrfToken);
        //     }
        //     return headers;
        // } else {
            return headers;
        //}
    }

fetchData = async (url: string, query?: any): Promise<any> => {
        let mainKerbID = "";

        const user = globalStore.getState().app.user;
        const student = globalStore.getState().student.activeStudent;

        if (user.role != "student") {
            mainKerbID = student.kerbId;
        } else {
            mainKerbID = user.kerbId;
        }

        url = this.baseUrl + '/apis/mulesoft/ss_ssnetwork' + url;

        let queryString = "?student=" + mainKerbID;

        if (query)
            queryString += "&" + Object.keys(query).map(key => key + "=" + query[key]).join("&");

        return this.authService.checkAuthentication().then(async () => {
            try {
                const accessToken = await this.authService.getAccessToken();
                const options = {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                };
                const response = await fetch(url + queryString, options);

                if (response.status == 200) {
                    const sessionExpiredHeader = response.headers.get("com.sap.cloud.security.login");

                    if (sessionExpiredHeader) {
                        window.location.reload();
                    }

                    const data = await response.json();

                    return data;
                } else if (response.status == 403) {
                    const sessionExpiredHeader = response.headers.get("com.sap.cloud.security.login");

                    if (sessionExpiredHeader) {
                        window.location.reload();
                    }
                } else {
                    console.log(`%c` + `NOT 200 or 403 Response`.toUpperCase(), "color: red; font-weight: bold;");
                    return null;
                }
            } catch (error) {
                console.log(`%c` + `ERROR: `.toUpperCase(), "color: red; font-weight: bold;", error);
                //window.location.reload();
            }
        }).catch((error) => {
            console.error("Could Not Authenticate");
            console.error("Authentication Error Details:", {
                error: error,
                stage: this.stage,
                hostname: window.location.hostname,
                hostUrl: this.hostUrl,
                baseUrl: this.baseUrl,
                hasToken: !!window.localStorage.getItem('okta-token-storage')
            });
            //logic if not authenticated.
        });

    }

    fetchDataWithoutParameters = async (url: string, query?: any): Promise<any> => {
        url = this.baseUrl + '/apis/mulesoft/ss_ssnetwork' + url;

        let queryString = "";

        if (query)
            queryString += "?" + Object.keys(query).map(key => key + "=" + query[key]).join("&");

        return this.authService.checkAuthentication().then(async () => {
            try {
                const accessToken = await this.authService.getAccessToken();
                const options = {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                };
                const response = await fetch(url + queryString, options);
                if (response.status == 200) {
                    const sessionExpiredHeader = response.headers.get("com.sap.cloud.security.login");

                    if (sessionExpiredHeader) {
                        window.location.reload();
                    }

                    return await response.json();
                } else if (response.status == 403) {
                    const sessionExpiredHeader = response.headers.get("com.sap.cloud.security.login");

                    if (sessionExpiredHeader) {
                        window.location.reload();
                    }
                } else {
                    console.log(`%c` + `NOT 200 or 403 Response`.toUpperCase(), "color: red; font-weight: bold;");
                    return null;
                }
            } catch (error) {
                console.log(`%c` + `ERROR with no params: `.toUpperCase(), "color: red; font-weight: bold;", error);
            }
        }).catch((error) => {
            console.error("Could Not Authenticate");
            console.error("Authentication Error Details:", {
                error: error,
                stage: this.stage,
                hostname: window.location.hostname,
                hostUrl: this.hostUrl,
                baseUrl: this.baseUrl,
                hasToken: !!window.localStorage.getItem('okta-token-storage')
            });
        });
    }

    //Calls

    buildQueryParams = (): string => {
        return "";
    }

    initialize = async (): Promise<User> => {
        return await this.fetchDataWithoutParameters("/initialize");
    }

    getImage = async (kerbId: string): Promise<Blob> => {
        return await this.fetchDataWithoutParameters("/image/" + kerbId);
    }

    getBiographics = async (): Promise<Biographics> => {
        return await this.fetchData("/student/biographic");
    }

    getDegree = async (): Promise<Degree> => {
        return await this.fetchData("/student/degree");
    }

    getCurrentAdvisors = async (): Promise<Advisors> => {
        return await this.fetchData("/student/advisors");
    }

    getPreviousAdvisors = async (): Promise<Advisors> => {
        return await this.fetchData("/student/advisors/historic");
    }

    // Current and historic addresses/roommates/phone now come back together from a
    // single call - the backend merged /student/addresses/historic into this endpoint,
    // so there's no separate historic request to make anymore.
    getAddresses = async (): Promise<Addresses> => {
        return await this.fetchData("/student/addresses");
    }

    getFinancial = async (): Promise<Financial> => {
        return await this.fetchData("/student/financial");
    }

    getActivities = async (): Promise<Activity> => {
        return await this.fetchData("/student/activities");
    }

    getContacts = async (): Promise<Contacts> => {
        return await this.fetchData("/student/contacts");
    }

    getEmergencyContacts = async (): Promise<Contacts> => {
        const all = await this.getContacts();

        if (!all) {
            return Promise.resolve(null);
        }

        const current = {contacts: all.contacts.filter(itm => itm.contactType == "emergency")};

        return Promise.resolve(current);
    }

    getMissingPersonContacts = async (): Promise<Contacts> => {
        const all = await this.getContacts();

        if (!all) {
            return Promise.resolve(null);
        }

        const current = {contacts: all.contacts.filter(itm => itm.contactType == "missing")};

        return Promise.resolve(current);
    }

    getStudent = async (): Promise<Student> => {
        return await this.fetchData("/student");
    }

    getStudents = async (nameOrId: string, autoComplete: boolean): Promise<Students> => {
        return await this.fetchDataWithoutParameters("/students", {nameOrId: nameOrId, autoComplete: autoComplete});
    }

    getClasses = async (termCode: string): Promise<Classes> => {
        return await this.fetchData("/student/classes", {termCode: termCode});
    }

    getCurrentClasses = async (): Promise<Classes> => {
        return await this.fetchData("/student/classes");
    }

    getClassesHistoric = async (currentClass: any): Promise<Classes> => {
        const historicalData = await this.fetchData("/student/classes/historic");
        const currentClassResponse = await currentClass;

        if (historicalData && currentClass) {
            //Remove current term from historic data
            if (currentClassResponse.classes && currentClassResponse.classes.length > 0) {
                const currentTerm = currentClassResponse.classes[0].termCode;
                //For all the historical data entries
                for (let i = 0; i < historicalData.classes.length; i++) {
                    //If the current term is in the historical data
                    if (currentTerm === historicalData.classes[i].termCode) {
                        //Remove it
                        historicalData.classes.splice(i, 1);
                    }
                }
            }

        }

        return historicalData;
    }

    getSubject = async (subjectCode: any, subjectNumber: any, termCode: any): Promise<any> => {
        return await this.fetchData("/subject-v2", {
            subjectCode: subjectCode,
            subjectNumber: subjectNumber,
            termCode: termCode
        });
    }

    getCurrentPrograms = async (): Promise<Programs> => {
        return await this.fetchData("/student/programs");
    }

    getHistoricPrograms = async (): Promise<Programs> => {
        return await this.fetchData("/student/programs/historic");
    }

    getDegreeInformation = async (): Promise<DegreeInformation> => {
        return await this.fetchData("/student/degreeInformation");
    }

    getDegreeInformationHistoric = async (): Promise<DegreeInformation> => {
        return await this.fetchData("/student/degreeInformation/historic");
    }

    getDegreeAudit = async (): Promise<DegreeAudit> => {
        return await this.fetchData("/student/degreeAudit");
    }

    getLeavesOfAbsence = async (): Promise<LeavesOfAbsences> => {
        return await this.fetchData("/student/leavesOfAbsence");
    }

    getHolds = async (): Promise<Holds> => {
        return await this.fetchData("/student/holds");
    }

    getAdditionalInformation = async (): Promise<AdditionalInformation> => {
        return await this.fetchData("/student/additionalInformation");
    }

    getStudentSupportRecords = async (): Promise<StudentSupportRecords> => {
        return await this.fetchData("/student/studentSupportRecords");
    }

    getAccessLogRecords = async (): Promise<AccessLogRecords> => {
        return await this.fetchData("/student/accessLogRecords");
    }

    getPrivacySettings = async (): Promise<PrivacySettings> => {
        return await this.fetchData("/student/privacySettings");
    }

    getPrivacySettingsInit = async (kerbId: string): Promise<PrivacySettings> => {
        return await this.fetchDataWithoutParameters("/student/privacySettings", {student: kerbId});
    }

    getInstructors = async (subjectCode: string, subjectNumber: string, termCode: string): Promise<Instructors> => {
        return await this.fetchData("/subject/instructors", {
            subjectCode: subjectCode,
            subjectNumber: subjectNumber,
            termCode: termCode
        });
    }

    sendFeedback = async (email: Email): Promise<void> => {
        await fetch(this.baseUrl + "/email", {
            method: "post",
            headers: await this.getPostHeader(),
            body: JSON.stringify(email)
        }).then(function (response) {
            return response.json();
        });
    }

    setPrivacySettings = async (privacySettings: PrivacySetting): Promise<void> => {
        const setting = {
            "settingId": privacySettings.settingId,
            "isActive": privacySettings.isActive
        };

        await fetch(this.baseUrl + "/student/privacySettings", {
            method: "post",
            headers: await this.getPostHeader(),
            body: JSON.stringify(setting)
        }).then(function (response) {
            return response.json();
        });
    }
}

export default StudentController;
